import { render, staticRenderFns } from "./RatingService.vue?vue&type=template&id=7383f3f0&scoped=true&"
import script from "./RatingService.vue?vue&type=script&lang=js&"
export * from "./RatingService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7383f3f0",
  null
  
)

export default component.exports